import { Translate } from 'react-redux-i18n'
import {
  FORMAT,
  formatDateTime,
} from '../../../../../../../../helpers/datetime'
import { formatText } from '../../../../../../../../helpers/value'
import { EMPTY_VALUE } from '../../../../../../../../utils/common'
import { CustomTdCompanyName } from './CustomTdCompanyName'
import { CustomTdScore } from './CustomTdScore'

const TITLE_TABLE = [
  {
    title: '#',
    key: 'stt',
  },
  {
    title: 'corporateLinkageScore.companyName',
    key: 'organizationName',
  },
  {
    title: 'corporateLinkageScore.taxCode',
    key: 'taxCode',
  },
  {
    title: 'corporateLinkageScore.relationship',
    key: 'relationship',
  },
  {
    title: 'corporateLinkageScore.statementDate',
    key: 'dtStatementDate',
  },
  {
    title: 'corporateLinkageScore.score',
    key: 'creditRiskScore',
  },
  {
    title: 'corporateLinkageScore.companySize',
    key: 'companySizeName',
  },
  {
    title: 'corporateLinkageScore.industry',
    key: 'industry',
  },
]

export const TYPE_SORT_BY = {
  ORG_NAME: 'organizationName',
  RELATIONSHIP: 'relationship',
  SCORE: 'creditRiskScore',
  COMPANY_SIZE: 'companySizeName',
}

export const schemaTable = (isDynamicReport) =>
  TITLE_TABLE.map((item, index) => {
    const result = {
      title: <Translate value={item.title} />,
      colId: item.key,
      thStyle: {
        textAlign: 'left',
        textTransform: 'capitalize',
      },
      tdStyle: {
        textAlign: 'left',
        whiteSpace: 'nowrap',
      },
    }
    if (index === 0) {
      return {
        ...result,
        thStyle: {
          margin: 'start',
          textTransform: 'capitalize',
        },
        tdStyle: {
          whiteSpace: 'nowrap',
          textAlign: 'left',
        },
        render: (val, { rowIndex }) => {
          return rowIndex + 1
        },
      }
    }
    if (index === 1) {
      return {
        ...result,
        thStyle: {
          margin: 'start',
          textTransform: 'capitalize',
        },
        tdStyle: {
          textAlign: 'left',
        },
        sortable: isDynamicReport ? false : true,
        render: (val, { rowId }) => {
          if (isDynamicReport) return formatText(val.name)
          return <CustomTdCompanyName val={val} rowId={rowId} />
        },
      }
    }
    if (index === 3) {
      return {
        ...result,
        thStyle: { textTransform: 'capitalize' },
        tdStyle: {
          whiteSpace: 'nowrap',
          textAlign: 'left',
        },
        sortable: isDynamicReport ? false : true,
        render: (val) => {
          return val || EMPTY_VALUE
        },
      }
    }
    if (index === 4) {
      return {
        ...result,
        tdStyle: {
          whiteSpace: 'nowrap',
          textAlign: 'left',
        },
        render: (val, { locale }) => {
          return formatDateTime(val, FORMAT.DATE, locale) || EMPTY_VALUE
        },
      }
    }
    if (index === 5) {
      return {
        ...result,
        thStyle: {
          margin: 'auto',
          textTransform: 'capitalize',
          justifyContent: 'center',
        },
        tdStyle: {
          whiteSpace: 'nowrap',
          textAlign: 'center',
        },
        sortable: isDynamicReport ? false : true,
        render: (val, { rowId, locale }) => {
          return (
            <CustomTdScore
              val={val}
              rowId={rowId}
              locale={locale}
              isDynamicReport={isDynamicReport}
            />
          )
        },
      }
    }
    if (index === 6) {
      return {
        ...result,
        tdStyle: {
          whiteSpace: 'nowrap',
          textAlign: 'left',
        },
        sortable: isDynamicReport ? false : true,
        render: (val) => {
          return val
        },
      }
    }
    if (index === 7) {
      return {
        ...result,
        tdStyle: {
          textAlign: 'left',
          whiteSpace: 'normal',
        },
        render: (val) => {
          return val
        },
      }
    }
    return {
      ...result,
      render: (val) => {
        return val || EMPTY_VALUE
      },
    }
  })
